<template>
  <div class="setup-fee-markets-page" data-testid="setup-fee-markets-page">
    <page-header
      :title="t('Taxas de Implantação')"
      icon="pi pi-wallet"
    />

    <comprovantes-para-conferir />

    <div class="toolbar" data-testid="setup-fee-markets-toolbar">
      <app-button
        :label="t('Adicionar mercado')"
        icon="pi pi-plus"
        severity="primary"
        data-testid="setup-fee-market-create-btn"
        @click="openMarketModal()"
      />
    </div>

    <setup-fee-markets-table ref="tableRef" />
    <!-- Modal is registered globally in ModalManager.vue — no local instance here -->
  </div>
</template>

<script setup lang="ts">
import ComprovantesParaConferir from '../../implantacao/ComprovantesParaConferir.vue'
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { eventBus } from '../../../eventBus'
import { log } from '../../../utils/DebugLogger'
import PageHeader from '../../../ui/PageHeader.vue'
import AppButton from '../../../ui/AppButton.vue'
import SetupFeeMarketsTable from './SetupFeeMarketsTable.vue'

interface TableExposed {
  loadData: () => Promise<void>
}

const { t } = useI18n()
const tableRef = ref<TableExposed | null>(null)

function openMarketModal(): void {
  eventBus.emit('modal.setupFeeMarket.open')
}

onMounted(async () => {
  try {
    await tableRef.value?.loadData()
  } catch (err) {
    log('SetupFeeMarketsPage', 'onMounted', 'Erro ao carregar mercados', err)
  }
})
</script>

<style scoped>
.setup-fee-markets-page {
  padding: 24px;
}

.toolbar {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
</style>
